import { useMemo } from "react";
import iconMap, { IconName } from "../assets/icons";

export interface IconItem {
  id: number;
  name: IconName;
}

const useIconList = (): IconItem[] => {
  return useMemo(
    () =>
      (Object.keys(iconMap) as IconName[]).map((name, index) => ({
        id: index + 1,
        name,
      })),
    []
  );
};

export default useIconList;
